import { Helmet } from "react-helmet-async"

export default function Fallback() {
  return <Helmet>
    <title>{""}</title>
  </Helmet >
}